'use client';

import { ArrowRight } from 'lucide-react';
import { HubType as HubTypeEnum } from '@/types/hubs';
import IconAdaptive from '@/components/IconAdaptive';
import ImageAdaptive from '@/components/ImageAdaptive';

type HubMapPopupUnitProps = {
    hubType: string;
    hubName: string;
    hubSubName?: string;
    countryCd?: string;
    prefectureName?: string;
    icon?: string;
    hubNewsCount?: number;
    onOpenHubNews?: () => void;
};

export default function HubMapPopupUnit({
    hubType,
    hubName,
    hubSubName,
    countryCd,
    prefectureName,
    icon,
    hubNewsCount = 0,
    onOpenHubNews,
}: HubMapPopupUnitProps) {
    const isDisabled = hubNewsCount === 0;

    return (
        <div className="relative flex flex-col justify-center items-center w-full min-w-[200px] md:max-w-[300px] md:min-w-[300px] w-full bg-color-white-base rounded-xl px-4 py-4">
            <div className="absolute top-1 left-0">
                {countryCd && (
                    <div className="flex">
                        <div>
                            <ImageAdaptive
                                src={`/images/country/${countryCd}.svg`}
                                baseWidth={20}
                                breakpoints={{ md: 20 }}
                                className="mx-2"
                            />
                        </div>
                        {countryCd === 'jp' && (
                            <div className="flex items-center font-corp font-bold text-color-base text-xs mt-0.5">
                                {prefectureName}
                            </div>
                        )}
                    </div>
                )}
            </div>
            <div className="flex w-full mt-[25px]">
                <div className="flex justify-start">
                    <ImageAdaptive
                        src={`/images/hub/map/${icon}.svg`}
                        baseWidth={70}
                        breakpoints={{ md: 80 }}
                        className={
                            hubType === HubTypeEnum.festa || hubType === HubTypeEnum.stand
                                ? 'mr-[20px] md:mr-[25px]'
                                : ''
                        }
                    />
                </div>
                <div className="flex flex-col w-full">
                    <div className="flex mt-2 mb-2">
                        <div className="font-montserrat font-medium text-color-white-base text-xs bg-color-base rounded-3xl px-4">
                            {hubType}
                        </div>
                    </div>
                    <div className="flex font-corp font-bold text-sm md:text-base text-color-base">{hubName}</div>
                    <div className="pt-1"></div>
                    <div className="flex font-notojp font-medium text-xs text-color-co-gray-dark">
                        {hubSubName || ''}
                    </div>
                </div>
            </div>
            {onOpenHubNews && (
                <button
                    type="button"
                    disabled={isDisabled}
                    className={`flex justify-end items-center w-full mt-3 text-color-co-gray-dark transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed ${
                        isDisabled ? '' : 'hover:text-color-service-selected'
                    }`}
                    onClick={onOpenHubNews}
                >
                    <span className="flex items-baseline pr-[1px]">
                        <span className="font-notojp font-medium text-xs underline decoration-dotted underline-offset-2">
                            事例を見る
                        </span>
                        <span className="shrink-0 font-cantarell font-bold text-[10px] tabular-nums pl-1">
                            {hubNewsCount}件
                        </span>
                    </span>
                    <IconAdaptive Icon={ArrowRight} strokeWidth={2.0} baseSize={12} breakpoints={{ md: 14 }} />
                </button>
            )}
        </div>
    );
}
